define('OutSystems/ReactWidgets/List',["require", "exports", "tslib", "@outsystems/virtualized-list", "OutSystems/ClientRuntime/Flow", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/AnimatedGroup", "OutSystems/ReactView/ScrollExtensions", "OutSystems/ReactView/Widget", "prop-types", "react"], function (require, exports, tslib_1, virtualized_list_1, Flow, ObjectExtensions, Settings_1, AnimatedGroup_1, ScrollExtensions, Widget_1, PropTypes, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.List = void 0;
    var SCROLL_EVENTNAME = "scroll";
    var RESIZE_EVENTNAME = "resize";
    var ORIENTATION_CHANGE_EVENTNAME = "orientationchange";
    var List = (function (_super) {
        tslib_1.__extends(List, _super);
        function List(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.previousListLength = 0;
            _this.shouldLoadState = false;
            _this.isScrollEndingEventHandlerRunning = false;
            _this.scrollViewerRef = React.createRef();
            _this.isVirtualizationEnabled = List_1.shouldVirtualizeList(props);
            _this.shouldLoadState = _super.prototype.getScreenStateCache.call(_this).shouldLoad;
            return _this;
        }
        List_1 = List;
        List.prototype.serializeCustomStateProperties = function () {
            var scrollHostInfo = this.getScrollHostInfo();
            var scrollInfo = ScrollExtensions.getScrollInfo(scrollHostInfo.scrollHost);
            return {
                top: scrollInfo.scroll.y,
                left: scrollInfo.scroll.x,
            };
        };
        List.prototype.loadCustomStateProperties = function (customProperties) {
            var properties = customProperties;
            var scrollViewer = this.getScrollViewer();
            if (scrollViewer) {
                scrollViewer.scrollToOffset(properties.left, properties.top);
            }
            else {
                var scrollableParent = this.getScrollHostInfo().scrollHost;
                ScrollExtensions.setScrollOffset(scrollableParent, properties.left, properties.top);
            }
        };
        List.prototype.getInfiniteScrollThreshold = function () {
            if (this.infiniteScrollThreshold === undefined) {
                this.infiniteScrollThreshold = 2000;
                if (this.props.extendedProperties) {
                    var customInfiniteScrollThreshold = this.props.extendedProperties[List_1.InfiniteScrollThresholdName];
                    if (customInfiniteScrollThreshold !== undefined) {
                        this.infiniteScrollThreshold = parseInt(customInfiniteScrollThreshold, 10);
                    }
                }
            }
            return this.infiniteScrollThreshold;
        };
        List.prototype.getScreenStateCache = function () {
            var screenStateCache = _super.prototype.getScreenStateCache.call(this);
            return {
                navigationKey: screenStateCache.navigationKey,
                shouldSave: screenStateCache.shouldSave,
                shouldLoad: this.isVirtualizationEnabled ? this.shouldLoadState : screenStateCache.shouldLoad,
                state: screenStateCache.state,
            };
        };
        List.prototype.getChildContext = function () {
            var _this = this;
            return {
                ancestorGenerationNode: this._generationNode,
                getScreenStateCache: function () { return _this.getScreenStateCache(); },
                locale: this.context.locale,
            };
        };
        List.prototype.getScrollHostInfo = function () {
            if (!this.scrollHostInfo) {
                this.scrollHostInfo = ScrollExtensions.getScrollHostInfo(this.getHTMLNode());
            }
            return this.scrollHostInfo;
        };
        List.shouldVirtualizeList = function (props) {
            return (!props.extendedProperties ||
                (props.extendedProperties["disable-virtualization"] + "").toLowerCase() !== "true");
        };
        List.prototype.componentDidMount = function () {
            var _this = this;
            if (this.props.onScrollEnding) {
                this.executeAfterPaint(function () {
                    if (!_this.isDisposed) {
                        _this.scrollHandler = function () { return _this.tryFireScrollEndingEvent(); };
                        _this.deferredScrollHandler = function () { return _this.tryFireScrollEndingEvent(true); };
                        var scrollableElement = _this.getScrollHostInfo().scrollHost;
                        scrollableElement.addEventListener(SCROLL_EVENTNAME, _this.scrollHandler);
                        scrollableElement.addEventListener(RESIZE_EVENTNAME, _this.scrollHandler);
                        window.addEventListener(ORIENTATION_CHANGE_EVENTNAME, _this.deferredScrollHandler);
                    }
                });
            }
            this.storeListLength();
        };
        List.prototype.componentDidUpdate = function () {
            if (this.props.onScrollEnding && this.previousListLength !== this.props.source.length) {
                this.tryFireScrollEndingEvent();
            }
            this.storeListLength();
        };
        List.prototype.UNSAFE_componentWillUpdate = function (nextProps, nextState) {
            this.isVirtualizationEnabled = List_1.shouldVirtualizeList(nextProps);
        };
        List.prototype.storeListLength = function () {
            if (this.props.source_dataFetchStatus !== 0 &&
                this.props.source.length > 0) {
                this.previousListLength = this.props.source.length;
            }
        };
        List.prototype.componentWillUnmount = function () {
            if (this.scrollHandler) {
                var scrollableElement = this.getScrollHostInfo().scrollHost;
                scrollableElement.removeEventListener(SCROLL_EVENTNAME, this.scrollHandler);
                scrollableElement.removeEventListener(RESIZE_EVENTNAME, this.scrollHandler);
            }
            if (this.deferredScrollHandler) {
                window.removeEventListener(ORIENTATION_CHANGE_EVENTNAME, this.deferredScrollHandler);
            }
            this.scrollHostInfo = null;
        };
        List.prototype.tryFireScrollEndingEvent = function (deferred) {
            if (deferred === void 0) { deferred = false; }
            if (!this.isScrollEndingEventHandlerRunning) {
                var InfiniteScrollThreshold = this.getInfiniteScrollThreshold();
                var scrollHostInfo = this.getScrollHostInfo();
                var scrollInfo = ScrollExtensions.getScrollInfo(scrollHostInfo.scrollHost);
                if ((scrollInfo.scroll.y > 0 && scrollInfo.scroll.y > this.lastScrollTop) || deferred) {
                    if (scrollInfo.scroll.height <=
                        scrollInfo.scroll.y + scrollInfo.viewport.height + InfiniteScrollThreshold) {
                        this.executeScrollEndingEventHandler();
                    }
                }
                else if ((scrollInfo.scroll.x > 0 && scrollInfo.scroll.x > this.lastScrollLeft) || deferred) {
                    if (scrollInfo.scroll.width <=
                        scrollInfo.scroll.x + scrollInfo.viewport.width + InfiniteScrollThreshold) {
                        this.executeScrollEndingEventHandler();
                    }
                }
                this.lastScrollTop = scrollInfo.scroll.y;
                this.lastScrollLeft = scrollInfo.scroll.x;
            }
        };
        List.prototype.executeScrollEndingEventHandler = function () {
            var _this = this;
            this.isScrollEndingEventHandlerRunning = true;
            Flow.tryFinally(this.props.onScrollEnding, function () {
                _this.isScrollEndingEventHandlerRunning = false;
            });
        };
        List.prototype.renderListItems = function (startIndex, length) {
            if (this.props.source.length > 0) {
                return this.props.placeholders.content.render(this, this.props.source, null, startIndex, length, (0, Settings_1.getEnvParams)().PreserveListItemReactKey);
            }
            return null;
        };
        List.prototype.getScrollViewer = function () {
            return this.scrollViewerRef.current;
        };
        List.prototype.shouldSuspendAnimations = function () {
            if (Math.abs(this.previousListLength - this.props.source.length) !== 1) {
                return true;
            }
            if (this.isVirtualizationEnabled) {
                var scrollViewer = this.getScrollViewer();
                return !scrollViewer || !scrollViewer.isInitialized || scrollViewer.isScrolling;
            }
            return false;
        };
        List.prototype.renderListWrapper = function (listWrapperAttributes, children) {
            var _this = this;
            var disabledAnimation = true;
            if (!disabledAnimation && this.props.animateItems) {
                var listAnimationAttributes = {
                    component: this.props.tag,
                    shouldSuspendAnimations: function () { return _this.shouldSuspendAnimations(); },
                };
                return React.createElement(AnimatedGroup_1.AnimatedGroup, ObjectExtensions.assign({}, listWrapperAttributes, listAnimationAttributes), children);
            }
            var tagFactory = React.createFactory(this.props.tag);
            return tagFactory(listWrapperAttributes, children);
        };
        List.prototype.render = function () {
            var _this = this;
            var listStatus = "";
            switch (this.props.source_dataFetchStatus) {
                case 0:
                    listStatus = " list-loading";
                    break;
                case 2:
                    listStatus = " list-error";
                    break;
                default:
                    break;
            }
            var listAttributes = {
                "data-list": "",
                "data-virtualization-disabled": !this.isVirtualizationEnabled ? "" : null,
                "data-animation-disabled": !this.props.animateItems ? "" : null,
                className: this.props.style + listStatus,
            };
            this.fillWithBuiltinProperties(listAttributes);
            if (this.isVirtualizationEnabled) {
                var viewportSafetyMarginBefore = void 0;
                var viewportSafetyMarginAfter = void 0;
                if (this.props.extendedProperties) {
                    viewportSafetyMarginBefore = parseInt(this.props.extendedProperties[List_1.ViewportSafetyMarginBefore], 10);
                    viewportSafetyMarginAfter = parseInt(this.props.extendedProperties[List_1.ViewportSafetyMarginAfter], 10);
                }
                var virtualizedProperties = {
                    renderWrapper: function (children) {
                        return _this.renderListWrapper(listAttributes, children);
                    },
                    renderItems: function (startIndex, length) {
                        return _this.renderListItems(startIndex, length);
                    },
                    length: this.props.source.length,
                    ref: this.scrollViewerRef,
                    viewportSafetyMarginBefore: viewportSafetyMarginBefore ? viewportSafetyMarginBefore : null,
                    viewportSafetyMarginAfter: viewportSafetyMarginAfter ? viewportSafetyMarginAfter : null,
                    initializationCompleted: function () {
                        _this.shouldLoadState = false;
                    },
                    enableFixStackDirection: (0, Settings_1.getEnvParams)().EnableFixVirtualizationStackDetection,
                };
                return React.createElement(virtualized_list_1.VirtualizedScrollViewer, ObjectExtensions.assign({}, listAttributes, virtualizedProperties));
            }
            else {
                return this.renderListWrapper(listAttributes, this.renderListItems());
            }
        };
        var List_1;
        List.InfiniteScrollThresholdName = "infinite-scroll-threshold";
        List.ViewportSafetyMarginBefore = "virtualization-threshold-before";
        List.ViewportSafetyMarginAfter = "virtualization-threshold-after";
        List.childContextTypes = ObjectExtensions.assign({
            getScreenStateCache: PropTypes.func,
        }, Widget_1.Widget.childContextTypes);
        List = List_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], List);
        return List;
    }(Widget_1.Widget));
    exports.List = List;
});
//# sourceMappingURL=List.js.map;
